<script setup lang="ts">
    import NavIcons, { type icons } from '@navigation/NavIcons.vue';
    import BsAlert from '@shared/components/BsAlert.vue';
    import { AlertTypes } from '@shared/components/BsAlerts';

    interface InsightsReportType {
        key: string;
        title: string;
        description: string;
        icon: icons;
        // Route name of the report; reports without one are not available yet
        routeName?: string;
    }

    const REPORT_TYPES: InsightsReportType[] = [
        {
            key: 'issues',
            title: 'Email',
            description: 'Monthly overview of your sent mailings: delivery, opens, clicks, unsubscribes, devices and locations.',
            icon: 'email',
            routeName: 'InsightsIssuesReport',
        },
        {
            key: 'sms',
            title: 'SMS',
            description: 'Sent text messages, delivery and clicks per month.',
            icon: 'textmessage',
        },
        {
            key: 'surveys',
            title: 'Surveys',
            description: 'Responses and completion rate across your surveys.',
            icon: 'survey',
        },
        {
            key: 'events',
            title: 'Events',
            description: 'Registrations and attendance for your events.',
            icon: 'event',
        },
    ];
</script>

<template>
    <div class="container-fluid p-lg-b">
        <header>
            <h1 class="m-xs-b">{{ $Resources.InsightsReportsMenuItem }}</h1>
            <p class="m-lg-b">Choose a report to view</p>
        </header>

        <BsAlert
            class="m-lg-b"
            :type="AlertTypes.Info"
            :dismissible="false"
            title="Demo page"
            content="This page is for demonstration purposes only. The reports do not show real data yet." />

        <ul class="tile-grid list-unstyled">
            <li v-for="report in REPORT_TYPES" :key="report.key" class="d-flex flex-direction-col">
                <span class="create-new-icon">
                    <NavIcons :icon="report.icon"></NavIcons>
                </span>

                <h3 class="strong">{{ report.title }}</h3>
                <p class="m-lg-b">{{ report.description }}</p>

                <div class="form-group m-auto-t">
                    <router-link
                        v-if="report.routeName"
                        :to="{ name: report.routeName }"
                        class="btn btn-primary btn-lg btn-block d-flex align-items-center gap-sm justify-content-center">
                        View report
                    </router-link>
                    <button v-else type="button" class="btn btn-default btn-lg btn-block" disabled>Coming soon</button>
                </div>
            </li>
        </ul>
    </div>
</template>

